import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadIcon, Alert, BodyText, CaptionText, BlockIcon, PAYPAL_THEME } from '@paypalcorp/pp-react';
import { get } from 'lodash';
const { sysColorBackgroundMediumContrast, sysColorWarningAlt } = PAYPAL_THEME;
export const DragDropImage = ({
    onChange,
    messages,
    image = {}
}) => {
    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: 1,
        accept: [
            'image/gif',
            'image/jpg',
            'image/jpeg',
            'image/png'
        ],
        maxSize: 12582912,
        onDrop: useCallback((acceptedFiles) => {
            acceptedFiles.map((file) => {
                onChange({ file: file, src: URL.createObjectURL(file), openModal: true });
            });
        }, []),
        onDropRejected: (rejections) => {
            onChange({ src: !image.openModal && image.src, error: get(rejections[0], 'errors[0].code', 'try-again'), openModal: image.openModal });
        },
    });

    const ImageContainer = () => {
        if (image.src) {
            return <div className="logo" style={{ background: `url(${image.src}) center center / contain no-repeat, center center` }} />;
        } else if(image.error){
            return <BlockIcon size="lg" style={{ color: sysColorWarningAlt }} />
        } else {
            return <UploadIcon size="lg" />
        }
    }

    return (
        <>
            <div className={`profileLogo ${image.error && 'logoError'}`} style={{
                cursor: 'pointer'
            }} {...getRootProps()}>
                <>
                    <input id="dropzone-input" {...getInputProps()} />
                    <label style={{ display: 'none' }} htmlFor="dropzone-input">{messages.logo.dragDrop}</label>
                    {ImageContainer()}
                </>
            </div>
            {!image.openModal && <div style={{ textAlign: 'center', marginTop: '0.5rem' }}>
                <BodyText>{messages.logo.dragDrop}</BodyText>
                <CaptionText style={{ color: sysColorBackgroundMediumContrast }}>{messages.logo.allowedType}</CaptionText>
            </div>}
            {image.error &&
                <div style={{ maxWidth: '31rem', margin: '0 auto' }}>
                    <Alert style={{ marginTop: '0.5rem' }} type="error">{get(messages, `logo.error.${image.error}`)}</Alert>
                </div>}
        </>
    );
}